module.exports = __webpack_public_path__ + "img/pr-2.8b332002.png";